import { isUndefined } from 'lodash';
import { translate } from '../../../i18n/I18nProvider';
import checkEuIccNumber from '../../../utils/checkEuIccNumber';

export default async function validateEuicc({
  euicc,
  currentNetwork,
  clientId
}) {
  const { icc, network } = await checkEuIccNumber(euicc, clientId);

  if (isUndefined(icc)) {
    return {
      info: {
        text: translate('VALIDATION.NOT_VALID_AVAILABLE').split('/')[0],
        isError: true
      }
    };
  }

  const isDifferentNetwok = currentNetwork?.operator !== network;

  if (isDifferentNetwok) {
    return {
      info: {
        text: translate('VALIDATION.DIFFERENT_NETWORK'),
        isError: true
      }
    };
  }

  return {
    icc: icc.slice(6),
    info: {
      text: translate('VALIDATION.CORRECT_NUMBER'),
      isError: false
    }
  };
}
